import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import App from "./App.tsx";
import "./index.css";

import { ErrorBoundary } from '@/components/ErrorBoundary';
import { reloadOnceForChunkError } from '@/lib/chunkReload';

// Vite fires this when a lazy route's chunk fails to preload (usually a stale deploy:
// old index.html pointing at chunk hashes that no longer exist). Reload onto the fresh build.
window.addEventListener('vite:preloadError', ((event: Event) => {
  event.preventDefault();
  reloadOnceForChunkError();
}) as EventListener);

createRoot(document.getElementById("root")!).render(
  <HelmetProvider>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </HelmetProvider>
);
